import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoresService {

  //animate
  public animate:boolean = false;

    // start animate
    animateSubject = new Subject<any>();
    getAnimate(): Observable<any> {
      return this.animateSubject.asObservable();
    }

  constructor() { }

  startAnimate(vuale:boolean) {
    this.animate = vuale;
    this.animateSubject.next(this.animate);
  }
}
